import { jwtDecode } from "jwt-decode";
function getRole() {
  const token = localStorage.getItem("accessToken")
    ? JSON.parse(localStorage.getItem("accessToken"))
    : null;
  const remember = localStorage.getItem("REMEMBERME")
    ? JSON.parse(localStorage.getItem("REMEMBERME"))
    : false;
  const role = {
    isLogin: sessionStorage.getItem("isLogin") || false,
    rememberme: remember,
    token: token,
    roles: null,
  };

  if ((!role.isLogin && !role.rememberme) || !role.token) {
    role.token = "";
    role.roles = null;
    role.rememberme = false;
  }
  if (role.token) {
    function getCurrentUser() {
      const token = localStorage.getItem("accessToken") || "";
      try {
        const decode = jwtDecode(token);
        role.roles = decode.roles;
        role.userName = decode.username;
      } catch (error) {
        return null;
      }
    }
    getCurrentUser();
  }
  return role;
}

export default getRole;
